import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import {
    Button,
    LoadingSpinner,
    toast,
    ColContainer,
    RowContainer,
    Typography,
    Input,
} from '../common';
import { GetTPSLookUp } from '../../services/Api/tpsLookUp/useApiTpsLookUp';

const TPSLookup = ({ submitOverride }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [TPSCheck, setTPSCheck] = useState(null);
    const [isOnRegister, setIsOnRegister] = useState(false);
    const [overrideReason, setOverrideReason] = useState('');

    const submitTPSOverride = () => {
        setIsLoading(true);
        submitOverride({ Number: TPSCheck.CheckNumber.Number, Reason: overrideReason });
        resetTPSValues();
        setIsLoading(false);
    };

    const resetTPSValues = () => {
        setTPSCheck(null);
        setIsOnRegister(false);
        setOverrideReason('');
    };

    const onSubmit = (data) => {
        setIsLoading(true);
        GetTPSLookUp({ number: data.telephone })
            .then((response) => {
                if (response && response?.status === 200) {
                    setTPSCheck(response.data);
                    const newIsOnRegister = response.data?.CheckNumber?.ResultDetailed?.List.some(
                        (result) => result['#text'] === 'True'
                    );
                    setIsOnRegister(newIsOnRegister);
                    setIsLoading(false);
                } else {
                    toast.error();
                    setIsLoading(false);
                }
            })
            .catch((e) => {
                toast.error(
                    "Something went wrong. Please make sure you've entered a valid phone number."
                );
                setIsLoading(false);
            });
    };

    const dialNumber = () => {
        const agent = new window.connect.Agent();
        const numberToDial = TPSCheck.CheckNumber.Number.replace(/^0/, '+44 ');
        agent.connect(window.connect.Endpoint.byPhoneNumber(numberToDial), {
            failure: () =>
                toast.error(
                    'Sorry, this number cannot be dialled automatically right now. Please try manually.'
                ),
        });
    };

    if (isLoading) return <LoadingSpinner />;

    return (
        <>
            {TPSCheck ? (
                <ColContainer spacing="large">
                    <ColContainer spacing="small">
                        <RowContainer spacing="small" className="mb-3 items-baseline">
                            <Typography variant="heading2.2">Results for</Typography>
                            <span onClick={() => dialNumber()}>
                                <Typography
                                    variant="heading2.1"
                                    color="brand-dark"
                                    className="cursor-pointer"
                                >
                                    {TPSCheck.CheckNumber.Number}
                                </Typography>
                            </span>
                            <Typography color="grey-normal" variant="body3">
                                (Click number to dial now)
                            </Typography>
                        </RowContainer>
                        {TPSCheck?.CheckNumber?.ResultDetailed?.List.map((result) => {
                            return (
                                <TPSResultsDiv
                                    key={result['@Name']}
                                    result={result['#text'] === 'True'}
                                    listName={result['@Name']}
                                    dateRegistered={result['@RegisteredDate']}
                                />
                            );
                        })}
                    </ColContainer>
                    {isOnRegister ? (
                        <Input
                            label="Set Reason for TPS Override"
                            value={overrideReason}
                            onChange={(e) => setOverrideReason(e.target?.value || '')}
                        />
                    ) : (
                        <></>
                    )}
                    <RowContainer spacing="button">
                        {isOnRegister ? (
                            <Button
                                disabled={(overrideReason || '').trim() === ''}
                                type="primary"
                                onClick={() => submitTPSOverride()}
                            >
                                Submit
                            </Button>
                        ) : (
                            <></>
                        )}
                        <Button onClick={() => resetTPSValues()}>Check another</Button>
                    </RowContainer>
                </ColContainer>
            ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ColContainer>
                        <Typography variant="body3" color="grey-normal" className="pb-1">
                            Enter a telephone number
                        </Typography>
                        <input
                            autoComplete="false"
                            className={`transition-all text-14/18 text-grey-dark active:text-black disabled:text-grey-normal placeholder-grey-normal py-3 px-6 bg-white active:bg-white disabled:bg-grey-light border rounded-lg outline-none ${
                                errors.telephone
                                    ? 'border-error'
                                    : 'active:border-grey-dark hover:border-grey-dark disabled:border-grey-light'
                            }`}
                            placeholder="Enter a telephone number to perform a TPS lookup"
                            {...register('telephone', { required: true })}
                        />
                        <Typography variant="body3" color="error" className="pt-1">
                            {errors.telephone ? 'Please enter a valid telephone number' : null}
                        </Typography>
                        <RowContainer className="pt-4">
                            <Button type="primary">Check</Button>
                        </RowContainer>
                    </ColContainer>
                </form>
            )}
        </>
    );
};

const TPSResultsDiv = ({ result, listName, dateRegistered = '' }) => {
    //May need to spilt the positive result into dateRegistered and !dateRegistered

    // No result found
    if (!result) {
        return (
            <RowContainer spacing="medium">
                <Typography variant="heading2.2" className="w-16">
                    {listName}{' '}
                </Typography>
                <Typography variant="body1.2" color="grey-dark">
                    Does not appear in the list
                </Typography>
            </RowContainer>
        );
    }

    // Result found - check for date for display reasons
    return (
        <>
            {dateRegistered !== '' ? (
                <RowContainer spacing="medium">
                    <Typography variant="heading2.2" className="w-16">
                        {listName}
                    </Typography>
                    <Typography variant="body1.2" color="error">
                        Registered on {dateRegistered}
                    </Typography>
                </RowContainer>
            ) : (
                <RowContainer spacing="medium">
                    <Typography variant="heading2.2" className="w-16">
                        {listName}
                    </Typography>
                    <Typography variant="body1.2" color="error">
                        Registered
                    </Typography>
                </RowContainer>
            )}
        </>
    );
};

export default TPSLookup;
